/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationRoleClaim } from './ApplicationRoleClaim';
import {
    ApplicationRoleClaimFromJSON,
    ApplicationRoleClaimFromJSONTyped,
    ApplicationRoleClaimToJSON,
    ApplicationRoleClaimToJSONTyped,
} from './ApplicationRoleClaim';
import type { ApplicationUserRole } from './ApplicationUserRole';
import {
    ApplicationUserRoleFromJSON,
    ApplicationUserRoleFromJSONTyped,
    ApplicationUserRoleToJSON,
    ApplicationUserRoleToJSONTyped,
} from './ApplicationUserRole';

/**
 * 
 * @export
 * @interface ApplicationRole
 */
export interface ApplicationRole {
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    normalizedName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    concurrencyStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationRole
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRole
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRole
     */
    isSyncAd?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationRole
     */
    userRoles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {Array<ApplicationRoleClaim>}
     * @memberof ApplicationRole
     */
    roleClaims?: Array<ApplicationRoleClaim> | null;
}

/**
 * Check if a given object implements the ApplicationRole interface.
 */
export function instanceOfApplicationRole(value: object): value is ApplicationRole {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ApplicationRoleFromJSON(json: any): ApplicationRole {
    return ApplicationRoleFromJSONTyped(json, false);
}

export function ApplicationRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'normalizedName': json['normalizedName'] == null ? undefined : json['normalizedName'],
        'concurrencyStamp': json['concurrencyStamp'] == null ? undefined : json['concurrencyStamp'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'clientId': json['clientId'],
        'isSyncAd': json['isSyncAd'] == null ? undefined : json['isSyncAd'],
        'userRoles': json['userRoles'] == null ? undefined : ((json['userRoles'] as Array<any>).map(ApplicationUserRoleFromJSON)),
        'roleClaims': json['roleClaims'] == null ? undefined : ((json['roleClaims'] as Array<any>).map(ApplicationRoleClaimFromJSON)),
    };
}

export function ApplicationRoleToJSON(json: any): ApplicationRole {
    return ApplicationRoleToJSONTyped(json, false);
}

export function ApplicationRoleToJSONTyped(value?: ApplicationRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'normalizedName': value['normalizedName'],
        'concurrencyStamp': value['concurrencyStamp'],
        'description': value['description'],
        'createdDate': value['createdDate'] == null ? value['createdDate'] : value['createdDate'].toISOString(),
        'clientId': value['clientId'],
        'isSyncAd': value['isSyncAd'],
        'userRoles': value['userRoles'] == null ? undefined : ((value['userRoles'] as Array<any>).map(ApplicationUserRoleToJSON)),
        'roleClaims': value['roleClaims'] == null ? undefined : ((value['roleClaims'] as Array<any>).map(ApplicationRoleClaimToJSON)),
    };
}

